// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import Toasted from 'vue-toasted';
import Vuetable from 'vuetable-2/src/components/Vuetable';
Vue.use(Vuetable);
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const authUser = window.localStorage.getItem('biyadmin');
    if (authUser) {
      next();
    } else {
      next({ name: 'Login' });
    }
  }
  next();
});
// you can also pass options, check options reference below
const Options = {
  duration: 4000
};
Vue.use(Toasted, Options);
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js